<div class="page-body-wrapper">
    <mat-accordion class="example-headers-align" multi>
        <mat-expansion-panel [expanded]="true">

            <!-- Action Buttons -->
            <div class="action-buttons" style="margin-top: 5px;">
                <button mat-raised-button color="primary" (click)="openRequestDialog()">
                    <mat-icon>add_circle</mat-icon>
                    YENİ KAYIT
                </button>
            </div>

            <!-- Tabs -->
            <mat-tab-group [(selectedIndex)]="selectedTab" class="custom-tab-group">
                <mat-tab label="Onay Bekleyenler" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="tab-content">
                        <!-- Filtreleme Alanları -->
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Tip Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedType1">
                                        <mat-option *ngFor="let type of typeList" [value]="type">
                                            {{type.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Proje Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedProject1">
                                        <mat-option *ngFor="let project of projectList" [value]="project">
                                            {{project.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart1" [formControl]="startDateFilterValue1">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart1"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart1></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd1" [formControl]="endDateFilterValue1">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd1"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd1 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput [(ngModel)]="searchFullName1">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>PO Numarası</mat-label>
                                    <input matInput [(ngModel)]="searchPoNumber1">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <button mat-raised-button color="warn" class="button-small" (click)="filterGrid(0)">
                                    Filtrele
                                </button>
                                <button mat-stroked-button class="button-small" (click)="clearFilterGrid(0)">
                                    Temizle
                                </button>
                            </div>
                        </div>

                        <table mat-table [dataSource]="dsWaitings" class="mat-elevation-z2">

                            <!-- Po Number -->
                            <ng-container matColumnDef="poNumber">
                                <th mat-header-cell *matHeaderCellDef>No</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.poNumber}}
                                </td>
                            </ng-container>

                            <!-- Created Date -->
                            <ng-container matColumnDef="createdDate">
                                <th mat-header-cell *matHeaderCellDef>Tarih</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.createdDate}}
                                </td>
                            </ng-container>

                            <!-- Full Name -->
                            <ng-container matColumnDef="fullName">
                                <th mat-header-cell *matHeaderCellDef>Talep Eden</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.fullName}}
                                </td>
                            </ng-container>

                            <!-- Type -->
                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef>Tip</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.type === 'REQUISITION' ? 'Talep' : 'Masraf'}}
                                </td>
                            </ng-container>

                            <!-- PG Grubu -->
                            <ng-container matColumnDef="pgGroup">
                                <th mat-header-cell *matHeaderCellDef>Satınalma Üst Grubu</th>
                                <td mat-cell *matCellDef="let element"> {{element.pgCodeDesc}}</td>
                            </ng-container>

                            <!-- PGD Grubu ack-->
                            <ng-container matColumnDef="pgdGroup">
                                <th mat-header-cell *matHeaderCellDef>Satınalma Alt Grubu</th>
                                <td mat-cell *matCellDef="let element"> {{element.pgdCodeDesc}}</td>
                            </ng-container>

                            <!-- Durum -->
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Durum</th>
                                <td mat-cell *matCellDef="let element">
                                    <span class="status-badge status-bekleyen">{{element.status}}</span>
                                </td>
                            </ng-container>

                            <!-- Aksiyonlar -->
                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef >İşlemler</th>
                                <td mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button 
                                            matTooltip="Görüntüle"
                                            class="action-button detail-button"
                                            (click)="viewRequest(element)">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                            matTooltip="Onayla"
                                            class="action-button approve-button"
                                            (click)="approveRequest(element)">
                                            <mat-icon>check_circle</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                            matTooltip="Reddet"
                                            class="action-button reject-button"
                                            (click)="rejectRequest(element)">
                                            <mat-icon>highlight_off</mat-icon>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </mat-tab>

                <mat-tab label="Taleplerim">
                    <div class="tab-content">
                        <!-- Filtreleme Alanları -->
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Tip Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedType2">
                                        <mat-option *ngFor="let type of typeList" [value]="type">
                                            {{type.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Proje Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedProject2">
                                        <mat-option *ngFor="let project of projectList" [value]="project">
                                            {{project.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart2" [formControl]="startDateFilterValue2">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart2"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart2></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd2" [formControl]="endDateFilterValue2">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd2"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd2 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput [(ngModel)]="searchFullName2">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>PO Numarası</mat-label>
                                    <input matInput [(ngModel)]="searchPoNumber2">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <button mat-raised-button color="warn" class="button-small" (click)="filterGrid(1)">
                                    Filtrele
                                </button>
                                <button mat-stroked-button class="button-small" (click)="clearFilterGrid(1)">
                                    Temizle
                                </button>
                            </div>
                        </div>

                        <table mat-table [dataSource]="dsMyRequests" class="mat-elevation-z2">
                            <!-- Po Number -->
                            <ng-container matColumnDef="poNumber">
                                <th mat-header-cell *matHeaderCellDef>No</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.poNumber}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="createdDate">
                                <th mat-header-cell *matHeaderCellDef>Tarih</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.createdDate}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="fullName">
                                <th mat-header-cell *matHeaderCellDef>Talep Eden</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.fullName}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef>Tip</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.type === 'REQUISITION' ? 'Talep' : 'Masraf'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="pgGroup">
                                <th mat-header-cell *matHeaderCellDef>Satınalma Üst Grubu</th>
                                <td mat-cell *matCellDef="let element"> {{element.pgCodeDesc}}</td>
                            </ng-container>

                            <ng-container matColumnDef="pgdGroup">
                                <th mat-header-cell *matHeaderCellDef>Satınalma Alt Grubu</th>
                                <td mat-cell *matCellDef="let element"> {{element.pgdCodeDesc}}</td>
                            </ng-container>

                            <ng-container matColumnDef="wgGroup">
                                <th mat-header-cell *matHeaderCellDef>İş Kolu</th>
                                <td mat-cell *matCellDef="let element">{{element.wgCode}}</td>
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Durum</th>
                                <td mat-cell *matCellDef="let element">
                                    <span class="status-badge status-tamamlanan">{{element.status}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef>İşlemler</th>
                                <td mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button 
                                            matTooltip="Görüntüle"
                                            class="action-button detail-button"
                                            (click)="viewRequest(element)">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </mat-tab>
                <mat-tab label="Onayladıklarım" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="tab-content">
                        <!-- Filtreleme Alanları -->
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Tip Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedType3">
                                        <mat-option *ngFor="let type of typeList" [value]="type">
                                            {{type.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Proje Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedProject3">
                                        <mat-option *ngFor="let project of projectList" [value]="project">
                                            {{project.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart3" [formControl]="startDateFilterValue3">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart3"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart3></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd3" [formControl]="endDateFilterValue3">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd3"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd3 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput [(ngModel)]="searchFullName3">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>PO Numarası</mat-label>
                                    <input matInput [(ngModel)]="searchPoNumber3">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <button mat-raised-button color="warn" class="button-small" (click)="filterGrid(2)">
                                    Filtrele
                                </button>
                                <button mat-stroked-button class="button-small" (click)="clearFilterGrid(2)">
                                    Temizle
                                </button>
                            </div>
                        </div>

                        <table mat-table [dataSource]="dsApproved" class="mat-elevation-z2">
                            <!-- Po Number -->
                            <ng-container matColumnDef="poNumber">
                                <th mat-header-cell *matHeaderCellDef>No</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.poNumber}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="erpNumber">
                                <th mat-header-cell *matHeaderCellDef>Erp No</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.erpNumber}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="createdDate">
                                <th mat-header-cell *matHeaderCellDef>Tarih</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.createdDate}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="fullName">
                                <th mat-header-cell *matHeaderCellDef>Talep Eden</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.fullName}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef>Tip</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.type === 'REQUISITION' ? 'Talep' : 'Masraf'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="pgGroup">
                                <th mat-header-cell *matHeaderCellDef>Satınalma Üst Grubu</th>
                                <td mat-cell *matCellDef="let element"> {{element.pgCodeDesc}}</td>
                            </ng-container>

                            <ng-container matColumnDef="pgdGroup">
                                <th mat-header-cell *matHeaderCellDef>Satınalma Alt Grubu</th>
                                <td mat-cell *matCellDef="let element"> {{element.pgdCodeDesc}}</td>
                            </ng-container>

                            <ng-container matColumnDef="wgGroup">
                                <th mat-header-cell *matHeaderCellDef>İş Kolu</th>
                                <td mat-cell *matCellDef="let element"> {{element.wgCodeDesc}}</td>
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Durum</th>
                                <td mat-cell *matCellDef="let element">
                                    <span class="status-badge status-tamamlanan">{{element.status}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef>İşlemler</th>
                                <td mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button 
                                            matTooltip="Görüntüle"
                                            class="action-button detail-button"
                                            (click)="viewRequest(element)">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsApproved"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsApproved;"></tr>
                        </table>
                    </div>
                </mat-tab>
                <mat-tab label="Reddettiklerim" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="tab-content">
                        <!-- Filtreleme Alanları -->
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Tip Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedType4">
                                        <mat-option *ngFor="let type of typeList" [value]="type">
                                            {{type.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Proje Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedProject4">
                                        <mat-option *ngFor="let project of projectList" [value]="project">
                                            {{project.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart4" [formControl]="startDateFilterValue4">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart4"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart4></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd4" [formControl]="endDateFilterValue4">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd4"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd4 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput [(ngModel)]="searchFullName4">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>PO Numarası</mat-label>
                                    <input matInput [(ngModel)]="searchPoNumber4">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <button mat-raised-button color="warn" class="button-small" (click)="filterGrid(3)">
                                    Filtrele
                                </button>
                                <button mat-stroked-button class="button-small" (click)="clearFilterGrid(3)">
                                    Temizle
                                </button>
                            </div>
                        </div>

                        <table mat-table [dataSource]="dsRejected" class="mat-elevation-z2">
                            <!-- Po Number -->
                            <ng-container matColumnDef="poNumber">
                                <th mat-header-cell *matHeaderCellDef>No</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.poNumber}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="createdDate">
                                <th mat-header-cell *matHeaderCellDef>Tarih</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.createdDate}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="fullName">
                                <th mat-header-cell *matHeaderCellDef>Talep Eden</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.fullName}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef>Tip</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.type === 'REQUISITION' ? 'Talep' : 'Masraf'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="pgGroup">
                                <th mat-header-cell *matHeaderCellDef>Satınalma Üst Grubu</th>
                                <td mat-cell *matCellDef="let element"> {{element.pgCodeDesc}}</td>
                            </ng-container>

                            <ng-container matColumnDef="pgdGroup">
                                <th mat-header-cell *matHeaderCellDef>Satınalma Alt Grubu</th>
                                <td mat-cell *matCellDef="let element"> {{element.pgdCodeDesc}}</td>
                            </ng-container>

                            <ng-container matColumnDef="wgGroup">
                                <th mat-header-cell *matHeaderCellDef>İş Kolu</th>
                                <td mat-cell *matCellDef="let element"> {{element.wgCodeDesc}}</td>
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Durum</th>
                                <td mat-cell *matCellDef="let element">
                                    <span class="status-badge status-reddedilen">{{element.status}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef >İşlemler</th>
                                <td mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button 
                                            matTooltip="Görüntüle"
                                            class="action-button detail-button"
                                            (click)="viewRequest(element)">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </mat-tab>
                <mat-tab label="Tüm Talepler" *ngIf="currentUser.manager || currentUser.hr">
                    <div class="tab-content">                        <!-- Filtreleme Alanları -->
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Tip Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedType5">
                                        <mat-option *ngFor="let type of typeList" [value]="type">
                                            {{type.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Proje Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedProject5">
                                        <mat-option *ngFor="let project of projectList" [value]="project">
                                            {{project.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Durum Seçiniz</mat-label>
                                    <mat-select [(value)]="selectedStatus5">
                                        <mat-option *ngFor="let status of statusList" [value]="status">
                                            {{status.description}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Başlangıç Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerStart5" [formControl]="startDateFilterValue5">
                                    <mat-datepicker-toggle matSuffix [for]="pickerStart5"></mat-datepicker-toggle>
                                    <mat-datepicker startView="multi-year" #pickerStart5></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row filter-wrapper">
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Bitiş Tarihi</mat-label>
                                    <input readonly matInput [matDatepicker]="pickerEnd5" [formControl]="endDateFilterValue5">
                                    <mat-datepicker-toggle matSuffix [for]="pickerEnd5"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEnd5 startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Ad Soyad</mat-label>
                                    <input matInput [(ngModel)]="searchFullName5">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field class="full-width">
                                    <mat-label>PO Numarası</mat-label>
                                    <input matInput [(ngModel)]="searchPoNumber5">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <button mat-raised-button color="warn" class="button-small" (click)="filterGrid(4)">
                                    Filtrele
                                </button>
                                <button mat-stroked-button class="button-small" (click)="clearFilterGrid(4)">
                                    Temizle
                                </button>
                            </div>
                        </div>
                         <table mat-table [dataSource]="dsAllRequests" class="mat-elevation-z2">
                            <!-- Po Number -->
                            <ng-container matColumnDef="poNumber">
                                <th mat-header-cell *matHeaderCellDef>No</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.poNumber}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="createdDate">
                                <th mat-header-cell *matHeaderCellDef>Tarih</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.createdDate}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="fullName">
                                <th mat-header-cell *matHeaderCellDef>Talep Eden</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.fullName}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef>Tip</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.type === 'REQUISITION' ? 'Talep' : 'Masraf'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="pgGroup">
                                <th mat-header-cell *matHeaderCellDef>Satınalma Üst Grubu</th>
                                <td mat-cell *matCellDef="let element"> {{element.pgCodeDesc}}</td>
                            </ng-container>

                            <ng-container matColumnDef="pgdGroup">
                                <th mat-header-cell *matHeaderCellDef>Satınalma Alt Grubu</th>
                                <td mat-cell *matCellDef="let element"> {{element.pgdCodeDesc}}</td>
                            </ng-container>

                            <ng-container matColumnDef="wgGroup">
                                <th mat-header-cell *matHeaderCellDef>İş Kolu</th>
                                <td mat-cell *matCellDef="let element"> {{element.wgCodeDesc}}</td>
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Durum</th>
                                <td mat-cell *matCellDef="let element">
                                    <span class="status-badge status-tamamlanan">{{element.status}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef>İşlemler</th>
                                <td mat-cell *matCellDef="let element" class="actions-mat-cell">
                                    <div class="action-buttons-container">
                                        <button mat-icon-button 
                                            matTooltip="Görüntüle"
                                            class="action-button detail-button"
                                            (click)="viewRequest(element)">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </mat-tab>
            </mat-tab-group>

        </mat-expansion-panel>
    </mat-accordion>
</div>
